// extracted by mini-css-extract-plugin
export default {"items":"item-flip-and-stretch-options-module__items--BaNWq","itemContainer":"item-flip-and-stretch-options-module__itemContainer--rEYCF"};